import OnboardingData from "./OnboardingData";

export default OnboardingData;
